<p-toast></p-toast>
<div class="card">
    <div class="card request-solar-container p-5">
        <div class="p-fluid p-formgrid grid justify-content-center">
            <h5>{{ "WRITE_YOUR_QUERY" | translate }}</h5>
            <div class="field col-12 md:col-12">
                <textarea id="description" [(ngModel)]="query" placeholder="Write your query here" pInputTextarea
                    required rows="10" cols="20" class="mr-3"></textarea>
            </div>
        </div>
        <div class="p-fluid p-formgrid grid justify-content-between">
            <div class="field col-12 md:col-6">
                <span>{{ "PASSWORD" | translate }}</span>
                <p-password [(ngModel)]="password" [toggleMask]="true" placeholder="Enter Password" [feedback]="false"></p-password>
            </div>

            <div class="field col-12 md:col-4">
                <span class="hide">{{ "sub" | translate }}</span>
                <button (click)="onSubmit()" pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
                    class="p-button-success mr-2 mb-2" [disabled]="false"></button>
            </div>
        </div>
    </div>

    <!-- table data start -->
    <div *ngIf="isSubmitted && (tableData.length == 0 || tableData == null)" class="p-fluid p-formgrid grid justify-content-center">
        <h5>{{ "No Data Found" }}</h5>
    </div>
    <div class="card dashboardTable" style="margin: 5px" *ngIf="tableData.length > 0">
        <p-table #queryDataTable [value]="tableData" dataKey="id" [rows]="25" [paginator]="true"
            [globalFilterFields]="tableColumns" responsiveLayout="scroll" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'QUERY_RESPONSE_DATA'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="queryDataTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let item of tableColumns" pSortableColumn={{item}}>{{item}}
                        <p-columnFilter type="text" field={{item}} display="menu"></p-columnFilter>
                        <p-sortIcon field={{item}}></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [ngStyle]="{'color': 'black'}">
                    <td *ngFor="let item of tableColumns">{{product[item]}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between">
                    {{'IN_TOTAL_THERE_ARE'| translate}}
                    {{ tableData ? tableData.length : 0 }} {{'ROWS'| translate}}
                </div><br>
            </ng-template>
        </p-table>
    </div>
    <!-- table data end -->
</div>